module.exports = __webpack_public_path__ + "assets/img/yiBinCongLinYueYe.e2b4357f.png";